'use client'
import React from 'react'

import { SwitcherFilter, SwitcherFilterProps } from '../Filter'

interface TimelineSwitcherFilterProps extends SwitcherFilterProps {}

export const TimelineSwitcherFilter = ({ ...props }: TimelineSwitcherFilterProps): JSX.Element => {
    return <SwitcherFilter isStretched className="h-10" {...props} />
}
